import * as React from "react";
import {NavLink} from "react-router-dom";


interface INavItemProps {
    key: number;
    url: string;
    icon: string;
    action: string;
}

export class NavDropdownItem extends React.Component<INavItemProps, {}> {
    private myRef: any;

    constructor(props: INavItemProps) {
        super(props);
        this.clickRemove = this.clickRemove.bind(this);
        this.myRef = React.createRef();
    }

    private clickRemove() {
        this.myRef.current.offsetParent.offsetParent.children[0].click();
        this.forceUpdate()
    }

    render() {
        return <li className="kt-menu__item " aria-haspopup="true" onClick={this.clickRemove}
            ref={this.myRef}>
            <a href={this.props.url} className="kt-menu__link">
                <i className={"kt-menu__link-icon fa " + this.props.icon}/>
                <span className="kt-menu__link-text dddd">{this.props.action}</span>
            </a>
        </li>;
    }
}



// WEBPACK FOOTER //
// ./src/layout/NavDropdownItem.tsx